export const isPerfectSquare = (x: number) => {
	let root = Math.sqrt(x);
	return ((root ** 2) == x);
}

// Returns true if n is a Fibinacci Number, else false
export const isFibonacci = (num: number) => {
    // n is Fibinacci if one of 5*n*n + 4 or 5*n*n - 4 or both
	// is a perferct square
	return isPerfectSquare(5 * num * num + 4) ||
		isPerfectSquare(5 * num * num - 4);
}